import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registrationMethod, captchaSiteKey } from "../../configs/auth";
import ReCAPTCHA from "react-google-recaptcha";
import toast from "react-hot-toast";


function Registration() {

    const [showPassword, setShowPassword] = useState(false);
    const [registrationData, setRegistrationData] = useState({
        name: '',
        email: '',
        password: '',
        ASZF: false
    });
    const [error, setError] = useState(false);
    const [errorText, setErrorText] = useState('');
    const navigate = useNavigate();
    const reCaptchaRef = useRef();

    const passwordStrengthRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>/=+-]).{8,}$/;

    const handleRegistration = async (e) => {
        e.preventDefault();

        // Ellenőrizzük, hogy a jelszó megfelel-e az erősségi előírásoknak
        if (!passwordStrengthRegex.test(registrationData.password)) {
            setError(true);
            setErrorText("A jelszónak tartalmaznia kell kis- és nagybetűt, számot és speciális karaktert!");
            return;
        }

        try {
            if (!registrationData.ASZF) {
                toast.error('A folytatáshoz el kell fogadnod a felhasználási feltételeket!', {duration: 8000});
                return;
            }
            const token = await reCaptchaRef.current.executeAsync();
            const result = await registrationMethod(registrationData, token);
            reCaptchaRef.current.reset();
            if (result.success) {
                navigate('/login');
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setRegistrationData((prevData) => ({
            ...prevData,
            [id]: value
        }));
    };


    return (
        <div className="container-fluid d-flex justify-content-center align-items-center p-0">
            <div className='col-lg-5 col-md-9 col-11 my-5 p-4 d-flex flex-column justify-content-center align-items-center border shadow'>
                <h4 className="mb-4">Regisztráció</h4>
                <form className='d-flex flex-column align-items-center col-10'>

                    <div className="form-floating mb-3">
                        <input type="text" className="form-control" id="name" placeholder="" value={registrationData.name} onChange={handleChange} required />
                        <label htmlFor="name">Név</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input type="email" className="form-control" id="email" placeholder="" value={registrationData.email} onChange={handleChange} required />
                        <label htmlFor="email">Email cím</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input type={showPassword ? 'text' : 'password'}  className="form-control" id="password" placeholder="" value={registrationData.password} onChange={handleChange} required minLength='8' />
                        <label htmlFor="password">Jelszó</label>
                        <span
                            className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                            onClick={() => setShowPassword(prevState => !prevState)}
                        >
                            <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true"></i>
                        </span>
                    </div>

                    {error && <p className="text-danger">{errorText}</p>}
                    
                    <ReCAPTCHA
                        sitekey={captchaSiteKey}
                        size="invisible"
                        ref={reCaptchaRef}
                    />

                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            checked={registrationData.ASZF}
                            onChange={() =>
                                setRegistrationData((prevData) => ({
                                    ...prevData,
                                    ASZF: !prevData.ASZF,
                                }))
                            }
                            id="ASZF"
                        />
                        <label className="form-check-label" htmlFor="ASZF">
                            Elolvastam és elfogadom az{' '}
                            <a href="/aszf.pdf" target="_blank" rel="noopener noreferrer">
                                Általános Szerződési Feltételeket,
                            </a>{' '}
                            tudomásul veszem az{' '}
                            <a href="/Adatvedelmi.pdf" target="_blank" rel="noopener noreferrer">
                                Adatkezelési Tájékoztatót
                            </a>
                            .
                        </label>

                        </div>

                    <div className="col-12 d-flex justify-content-center">
                        <button className='btn btn-home-primary my-3' onClick={(e) => handleRegistration(e)}>Regisztráció</button>
                    </div>
                </form>

                <div className='d-flex flex-row'>
                    <h6 className='m-0 me-2'>Van már fiókod?</h6>
                    <Link to='/login'>Itt tudsz bejelentkezni</Link>
                </div>
            </div>
        </div>
    );
}

export default Registration;